import {AfterViewInit, Component, forwardRef, Inject, Injector, OnInit, ViewChild} from '@angular/core';
import { Option} from '../model/option';
import { TourApiService } from '../services/tour-api.service';
import { TrackingService} from '../services/tracking.service';
import { ModalService } from '../services/modal.service';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { WishlistService } from '../services/wishlist.service';
import { AspectRatio } from '../model/image';
import { EnumAware } from '../decorators/enum-aware.decorator';
import { ImageListComponent } from '../shared/image-list.component';
import { TourService} from '../services/tour.service';
import { QueryPage, ReviewQuery} from '../model/product-review-query';

@Component({
  selector: 'gt-option-detail',
  templateUrl: './option-detail.component.html',
  styleUrls: ['./option-detail.component.css']
})
@EnumAware
export class OptionDetailComponent implements OnInit {

  AspectRatio = AspectRatio;
  option: Option;
  dialog: MatDialogRef<any>;
  @ViewChild(ImageListComponent)
  private imageListComponent: ImageListComponent;
  reviewsVisible = false;
  reviewsLoading = false;
  reviewQuery = new ReviewQuery();

  constructor(public dialogRef: MatDialogRef<any>,
              public tourService: TourService,
              public apiService: TourApiService,
              @Inject(forwardRef(() => ModalService)) public modalService,
              public wishlistService: WishlistService,
              private trackingService: TrackingService,
              @Inject(MAT_DIALOG_DATA) private data: any) {

    this.dialog = dialogRef;
    this.option = data;
  }

  ngOnInit() {
    if (this.option.productRatings != null && this.reviewQuery.results.length === 0) {
      this.fetchReviews(this.reviewQuery.queryParamsForPageType(0));
    }
    this.trackingService.trackAction(TrackingService.kActionViewOptionDetail, this.option.internalName, this.option.id);
  }

  showReviews() {
    this.reviewsVisible = true;
  }

  pageResults(pageType: QueryPage) {
    this.fetchReviews(this.reviewQuery.queryParamsForPageType(pageType));
  }

  hideReviews() {
    this.reviewsVisible = false;
  }

  firstThreeReviews() {
    return this.reviewQuery.results.slice(0, 3);
  }

  fetchReviews(queryParam: string) {
    this.reviewsLoading = true;
    this.apiService.fetchProductReviews(this.option.id, queryParam).subscribe(
      data => {
        this.reviewQuery.loadResults(data['results']);
        this.reviewsLoading = false;
      },
      error => {
        console.log(error);
        this.reviewsLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/option-detail.component.ts